@if (inputControl) {
  <rt-input
    [formControl]="inputControl.controls.gte"
    [placeholder]="'app.common.min' | translate"
    [asNumber]="true"
    type="number"
  />

  <rt-input
    [formControl]="inputControl.controls.lte"
    [placeholder]="'app.common.max' | translate"
    [asNumber]="true"
    type="number"
  />
}
